import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	insertExistingLoom: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-actions-menu.insert-existing-loom-item.insert-existing-loom',
		defaultMessage: 'Insert existing Loom',
		description: 'Click on this item to show a text field to insert an existing Loom video',
	},
	existingLoomVideo: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-actions-menu.insert-existing-loom-item.existing-loom-video',
		defaultMessage: 'Existing Loom video',
		description:
			'Click on this item to show a text field to insert an existing Loom video, for quick actions menu GA experiment only',
	},
});
